export default __webpack_public_path__ + "static/media/Gubee.2573ba1d.jpg";